import { EyeOutlined } from '@ant-design/icons';
import { Card } from '@components/common/Card/Card';
import { PageTitle } from '@components/common/PageTitle/PageTitle';
import { PagingType, UTable } from '@components/common/UTable/UTable';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { useGetDictionariesQuery } from '@/api/dictionaries/api';
import {
  useGetControlDataQuery,
  useGetControlInfoQuery,
} from '@/api/vaccination/control/api';
import { ARCHIVE, CONTROL, REGISTRY, VACCIANTION } from '@/constants/routes';
import { controlCardConfig } from '@/pages/Vaccination/components/control/card.config';
import { ControlInfo } from '@/pages/Vaccination/components/control/types';
import { OrganizationLevelType } from '@/shared/organizations/enums';
import { vaccination } from '@/shared/security/permissions/vaccination';
import { withSecurity } from '@/shared/security/withSecurity';
import { mapTableIndexWithPage } from '@/utils/utils';

import { columns } from './columns.config';

export const VaccinationControl = withSecurity(({ auth }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paging, setPaging] = useState<PagingType>({ page: 0, size: 10 });
  const authOrgId =
    (auth?.organization?.level === OrganizationLevelType.STRUCTURAL_DIVISION
      ? auth?.organization?.id
      : searchParams.get('organizationId')) || '';
  const orgId = searchParams.get('organizationId') || '';
  const orgName = searchParams.get('orgName') || '';

  const { data: dictionaries } = useGetDictionariesQuery();

  const { data: controlInfo } = useGetControlInfoQuery(
    { organizationId: authOrgId },
    { skip: !authOrgId },
  );

  const { data: controlData, isFetching } = useGetControlDataQuery(
    { filters: { organizationId: authOrgId }, paging },
    { skip: !authOrgId },
  );

  return (
    <div>
      <PageTitle title={`Мониторинг вакцинации на ${dayjs().format('DD.MM.YYYY')}`} />
      <PageTitle title={`Хозяйство: ${orgName}`} level={4} />
      <Card
        styles={{ marginTop: 0 }}
        viewMode={true}
        schema={controlCardConfig}
        data={controlInfo}
        actions={{
          extra: [
            {
              text: 'Архив',
              action: () =>
                navigate(VACCIANTION + CONTROL + ARCHIVE + `?organizationId=${orgId}`),
              buttonProps: {
                type: 'primary',
              },
              security: { permissions: vaccination.task.viewArchive },
            },
          ],
        }}
      />
      <UTable
        actionColumnWidth={50}
        size={'small'}
        data={mapTableIndexWithPage(controlData?.content, paging)}
        columns={columns(dictionaries?.dictMap)}
        loading={isFetching}
        paging={paging}
        total={controlData?.totalElements}
        onPagingChange={setPaging}
        style={{ marginTop: 15 }}
        actions={(record: ControlInfo) => [
          {
            icon: <EyeOutlined />,
            action: () => navigate(`${VACCIANTION}${REGISTRY}/${record.individualId}`),
            security: { permissions: vaccination.individual.viewPassport },
          },
        ]}
      />
    </div>
  );
});
